// listen for clicks on .editable elements
document.addEventListener("click", function(event) {
  if (event.target.closest(".editable")) {
    let editable = event.target.closest(".editable")
    editable.setAttribute("data-clickCount", Number(editable.getAttribute("data-clickCount")) + 1)
    if (editable.getAttribute("data-clickCount") == 5) {
      editable.contentEditable = true
      editable.focus()
    }
  }
})
